module.exports = __webpack_public_path__ + "static/media/caper.c4767b6b.png";